export const INT_WEB_LOGOUT = "int_web_logout";
export const INT_WEB_LOGIN = "int_web_login";
export const INT_WEB_SIGNUP = "int_web_signup";
